import React from "react";
import RateRow from "./RateRow";
import styled from "styled-components";
import classnames from "classnames";

export interface IRateProps {
    rates: any;
    onClick: (event: any, data: any) => void;
    className: string;
}

export default styled((props) => {

    const { rates, onClick, className }: IRateProps = props;
    return (
        <div className={classnames(className, "w-100", "p-0")}>
            <div className="row flex-column calculated-row-rates">
                {rates.map((rate, index) => {

                    const rowProps = {
                        rate,
                        onClick,
                        key: index
                    };

                    return <RateRow key={rate.id} {...rowProps} />;
                })}
            </div>
        </div>
    );
})`
    // Add padding to every other rate box
    ${RateRow}:nth-child(even){
        padding-top: 15px;
        padding-bottom: 15px;
    }

    // The first box will always have top padding
    ${RateRow}:first-child {
        padding-top: 15px;
    }

    // and the last will always have bottom padding
    ${RateRow}:last-child {
        padding-bottom: 15px;
    }
`;